import { Component } from '@angular/core';

@Component({
    template: `<div class="ui active inverted dimmer">
        <div class="ui loader"></div>
    </div>`,
})
export class LoadingRedirectView {}
